import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { GoogleSearchConsoleReconnectButton } from './GoogleSearchConsoleReconnectButton';
export const GoogleSearchConsoleReconnectionConfig = {
  reconnectButton: GoogleSearchConsoleReconnectButton,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED, AppConnectionStatuses.UPDATE_AVAILABLE]
};